import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './style.scss';
import { calculateHeight } from '../statisticsParentUtils';

export const StatisticsWorkMaterials = ({ obj, text, textTop }) => {
  const { t } = useTranslation();
  return (
    <div className="statistics-work-materials-block">
      <div className="statistics-work-materials-block-top">
        <div className="statistics-work-materials-text">
          <span className="statistics-work-materials-count">
            {obj.totalMaterialsCount} {t(textTop)}
          </span>
          <span className="statistics-work-materials-count-text">{t(text)}</span>
        </div>
      </div>

      <div className="statistics-work-materials-block-bottom">
        <ul className="statistics-work-materials-list">
          <li>
            <div
              className="pilar-item"
              style={{
                height: calculateHeight(obj.counts.currentMonth.count) + '%',
              }}
            >
              <div className="pilar-count">{obj.counts.currentMonth.count}</div>
            </div>
            <div className="pilar-month">
              <span>{t(obj.counts.currentMonth.month)}.</span>
            </div>
          </li>
          <li>
            <div
              className="pilar-item"
              style={{
                height: calculateHeight(obj.counts.oneMonthAgo.count) + '%',
              }}
            >
              <div className="pilar-count">{obj.counts.oneMonthAgo.count}</div>
            </div>
            <div className="pilar-month">
              <span>{t(obj.counts.oneMonthAgo.month)}.</span>
            </div>
          </li>
          <li>
            <div
              className="pilar-item"
              style={{
                height: calculateHeight(obj.counts.twoMonthsAgo.count) + '%',
              }}
            >
              <div className="pilar-count">{obj.counts.twoMonthsAgo.count}</div>
            </div>
            <div className="pilar-month">
              <span>{t(obj.counts.twoMonthsAgo.month)}.</span>
            </div>
          </li>
          <li>
            <div
              className="pilar-item"
              style={{
                height: calculateHeight(obj.counts.threeMonthsAgo.count) + '%',
              }}
            >
              <div className="pilar-count">{obj.counts.threeMonthsAgo.count}</div>
            </div>
            <div className="pilar-month">
              <span>{t(obj.counts.threeMonthsAgo.month)}.</span>
            </div>
          </li>
          <li>
            <div
              className="pilar-item"
              style={{
                height: calculateHeight(obj.counts.fourMonthsAgo.count) + '%',
              }}
            >
              <div className="pilar-count">{obj.counts.fourMonthsAgo.count}</div>
            </div>
            <div className="pilar-month">
              <span>{t(obj.counts.fourMonthsAgo.month)}.</span>
            </div>
          </li>
          <li>
            <div
              className="pilar-item"
              style={{
                height: calculateHeight(obj.counts.fiveMonthsAgo.count) + '%',
              }}
            >
              <div className="pilar-count">{obj.counts.fiveMonthsAgo.count}</div>
            </div>
            <div className="pilar-month">
              <span>{t(obj.counts.fiveMonthsAgo.month)}.</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};
